import {
  GET_NOTIFICATIONMANAGER,
  GET_NOTIFICATIONMANAGER_FAIL,
  GET_NOTIFICATIONMANAGER_SUCCESS,
  GET_NOTIFICATIONMANAGERS,
  GET_NOTIFICATIONMANAGERS_FAIL,
  GET_NOTIFICATIONMANAGERS_SUCCESS,
  ADD_NEW_NOTIFICATIONMANAGER,
  ADD_NOTIFICATIONMANAGER_SUCCESS,
  ADD_NOTIFICATIONMANAGER_FAIL,
  UPDATE_NOTIFICATIONMANAGER,
  UPDATE_NOTIFICATIONMANAGER_SUCCESS,
  UPDATE_NOTIFICATIONMANAGER_FAIL,
  DELETE_NOTIFICATIONMANAGER,
  DELETE_NOTIFICATIONMANAGER_SUCCESS,
  DELETE_NOTIFICATIONMANAGER_FAIL,
  SET_STATE_NOTIFICATIONMANAGER,
  UPDATE_NOTIFICATIONMANAGERSTATUS,
  UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS,
  UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_NOTIFICATIONMANAGER,
  payload: loading,
})

export const getNotificationManagers = ( params ) => ({
  type: GET_NOTIFICATIONMANAGERS,
  payload: { params },
})

export const getNotificationManagersSuccess = (notificationManagers, totalPages, currentPage) => ({
  type: GET_NOTIFICATIONMANAGERS_SUCCESS,
  payload: { notificationManagers:notificationManagers, total:totalPages, currentPage:currentPage}
})

export const getNotificationManagersFail = error => ({
  type: GET_NOTIFICATIONMANAGERS_FAIL,
  payload: error,
})

export const addNewNotificationManager = notificationManager => ({
  type: ADD_NEW_NOTIFICATIONMANAGER,
  payload: notificationManager,
})

export const addNotificationManagerSuccess = notificationManager => ({
  type: ADD_NOTIFICATIONMANAGER_SUCCESS,
  payload: notificationManager,
})  

export const addNotificationManagerFail = error => ({
  type: ADD_NOTIFICATIONMANAGER_FAIL,
  payload: error,
})

export const updateNotificationManager = notificationManager => ({
  type: UPDATE_NOTIFICATIONMANAGER,
  payload: notificationManager,
})

export const updateNotificationManagerSuccess = notificationManager => ({
  type: UPDATE_NOTIFICATIONMANAGER_SUCCESS,
  payload: notificationManager,
})

export const updateNotificationManagerFail = error => ({
  type: UPDATE_NOTIFICATIONMANAGER_FAIL,
  payload: error,
})

export const updateNotificationManagerStatus = notificationManager => ({
  type: UPDATE_NOTIFICATIONMANAGERSTATUS,
  payload: notificationManager,
})

export const updateNotificationManagerStatusSuccess = notificationManager => ({
  type: UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS,
  payload: notificationManager,
})

export const updateNotificationManagerStatusFail = error => ({
  type: UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL,
  payload: error,
})

export const deleteNotificationManager = notificationManager => ({
  type: DELETE_NOTIFICATIONMANAGER,
  payload: notificationManager,
})

export const deleteNotificationManagerSuccess = id => ({
  type: DELETE_NOTIFICATIONMANAGER_SUCCESS,
  id,
})

export const deleteNotificationManagerFail = error => ({
  type: DELETE_NOTIFICATIONMANAGER_FAIL,
  payload: error,
})

export const getNotificationManager = () => ({
  type: GET_NOTIFICATIONMANAGER,
})

export const getNotificationManagerSuccess = notificationManager => ({
  type: GET_NOTIFICATIONMANAGER_SUCCESS,
  payload: notificationManager,
})

export const getNotificationManagerFail = error => ({
  type: GET_NOTIFICATIONMANAGER_FAIL,
  payload: error,
})
